<ng-container *transloco="let t">
  <div class="flex">
    <pxc-sidebar
      class="fixed top-0 z-40 h-screen w-3/4 shrink-0 border-r border-border-normal transition-all md:sticky"
      data-testid="sidebar"
      [collapsed]="sidebarService.collapsed"
      [ngClass]="{
        'max-md:-translate-x-full': !sidebarService.shown,
        'max-md:translate-x-0': sidebarService.shown,
        'md:w-16': sidebarService.collapsed,
        'md:w-64': !sidebarService.collapsed,
      }" />
    <main class="w-full shrink">
      <pxc-header class="sticky top-0 z-30" data-testid="navbar" />
      <pxc-paywall-alert />
      <router-outlet data-testid="content" />
    </main>
    <!-- This is the background overlay when sidebar is open on mobile -->
    <button
      class="fixed left-0 top-0 z-30 h-screen w-screen bg-accent-opposite/50 transition-all md:hidden"
      type="button"
      [ngClass]="{
        'hidden opacity-0': !sidebarService.shown,
        'opacity-100': sidebarService.shown,
      }"
      (click)="sidebarService.shown = false"></button>
  </div>
</ng-container>
